import React from 'react';
import { pageText } from '../utils/pageText';

/**
 * 统一的加载指示器组件
 */
export const LoadingSpinner = ({ size = 50, color = "#007bff", text = "Loading..." }) => {
  return (
    <div className="loading-spinner" role="status" aria-live="polite">
      <span
        className="loading-spinner-ring"
        style={{
          width: size,
          height: size,
          borderColor: `${color} rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1)`,
        }}
      />
      {text && <p>{pageText(text)}</p>}
    </div>
  );
};

export default LoadingSpinner;
